import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema, TOption } from "@/comn/hooks";

export const BASE = {
    path: `${lpcoEnvs.base}/ststcl`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/ststcl`,
    nodes: [
        // TODO 라벨 처리 필요
        { path: "/", label: "L_ESW" },
        { path: "/ststcl", label: "L_STSTCL" },
    ],
};

export const URLS = {};

export const APIS = {
    getStstclList: (data: any) => {
        return api.get(`${BASE.api}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getStstclHsCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/hs-cd?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getStstclOgaList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/oga?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getOrgLpcoRprt: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/oga-lpco-rprt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getHscdRprt: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/hscd-rprt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getCntyTrdeRprt: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/cnty-trde-rprt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getAlPayRprt: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/al-pay-rprt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getAlPayRprtSumm: (data: any) => {
        // 배열 응답은 여기서 추출해 반환 (useFetch가 최상위 배열값을 객체로 뭉개는 것 방지) !== 요약 배열 추출 ==!
        return api
            .get(`${BASE.api}/al-pay-rprt/summary`, { params: comnUtils.toGetParams(data) })
            .then((res: any) => res?.data?.alPayRprtSumm || []);
    },

    getAlPayRprtAll: (data: any) => {
        return api.get(`${BASE.api}/al-pay-rprt/all`, { params: comnUtils.toGetParams(data) });
    },

    getBllSttsRprt: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/bll-stts-rprt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getBllSttsRprtAll: (data: any) => {
        return api.get(`${BASE.api}/bll-stts-rprt/all`, { params: comnUtils.toGetParams(data) });
    },

    getBllSttsRprtSumm: (data: any) => {
        // 배열 응답은 여기서 추출해 반환 (useFetch가 최상위 배열값을 객체로 뭉개는 것 방지) !== 요약 배열 추출 ==!
        return api
            .get(`${BASE.api}/bll-stts-rprt/summary`, { params: comnUtils.toGetParams(data) })
            .then((res: any) => res?.data?.bllSttsRprtSumm || []);
    },

    getGfsCdRprt: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/gfs-cd-rprt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getGfsCdRprtAll: (data: any) => {
        return api.get(`${BASE.api}/gfs-cd-rprt/all`, { params: comnUtils.toGetParams(data) });
    },

    getGfsCdRprtSumm: (data: any) => {
        // 배열 응답은 여기서 추출해 반환 (useFetch가 최상위 배열값을 객체로 뭉개는 것 방지) !== 요약 배열 추출 ==!
        return api
            .get(`${BASE.api}/gfs-cd-rprt/summary`, { params: comnUtils.toGetParams(data) })
            .then((res: any) => res?.data?.gfsCdRprtSumm || []);
    },

    getSrchYearArr: (): TOption[] => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const endYear = 2022;

        let years: TOption[] = [];

        for (let year = currentYear; year >= endYear; year--) {
            years.push({ label: year + "", value: year + "" });
        }
        return years;
    },
    getSrchQuarterArr: () => {
        let quarters = [];
        quarters.push({ label: "Q1", value: "1" });
        quarters.push({ label: "Q2", value: "2" });
        quarters.push({ label: "Q3", value: "3" });
        quarters.push({ label: "Q4", value: "4" });
        return quarters;
    },
    getSrchMonthArr: () => {
        let months = [];
        for (let month = 1; month <= 12; month++) {
            const val = `${String(month).padStart(2, "0")}`;
            months.push({ label: val, value: val });
        }
        return months;
    },
    getStstclByTradeList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/trade?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

export const SF_SCHEMA_STSTCL_SELC: TFormSchema = {
    id: "form_ststcl",
    schema: {
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==! */,
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchAppCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            all: true,
        } /* LPCO !== LPCO ==! */,
        srchPrdDvnCd: {
            type: "radio",
            label: "L_TIME_ITRV",
            area: "comnCd",
            comnCd: "OSC0141",
            edit: true,
            excludes: ["H"],
        } /* Time Interval !== 시간 간격 ==! */,
        srchCustomRnge: {
            type: "daterange",
            label: "L_DT_RNGE",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchCustomStrtDt" },
            end: { name: "srchCustomEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 사용자 정의 날짜 간격 ==! */,
        srchStrYear: {
            type: "select",
            label: "L_STRT_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year !== 시작 년도 ==! */,
        srchEndYear: {
            type: "select",
            label: "L_END_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year !== 종료 년도 ==! */,
        srchStrQrtYy: {
            type: "select",
            label: "L_STRT_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Quarter Year !== 시작 분기 년도 ==! */,
        srchStrQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* Start Quarter !== 시작 분기 ==! */,
        srchEndQrtYy: {
            type: "select",
            label: "L_END_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Quarter Year !== 종료 분기 년도 ==! */,
        srchEndQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* End Quarter !== 종료 분기 ==! */,
        srchStrYmYy: {
            type: "select",
            label: "L_STRT_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year and Month !== 시작 연월 년도 ==! */,
        srchStrYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* Start Year and Month !== 시작 연월 월 ==! */,
        srchEndYmYy: {
            type: "select",
            label: "L_END_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year and Month !== 종료 연월 년도 ==! */,
        srchEndYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* End Year and Month !== 종료 연월 월 ==! */,
        srchRegmTpCd: {
            type: "select",
            label: "L_REGM_TP",
            area: "comnCd",
            comnCd: "OSC0159",
            excludes: ["TR", "TN", "FI", "FO"],
            edit: true,
            all: true,
        } /* Regime Type !== 영역 유형 ==! */,
        srchHsCd: {
            type: "code",
            label: "L_HS_CD",
            area: "hsCd",
            edit: true,
        } /* HS code !== HS code ==! */,
        appStts: {
            type: "select",
            label: "L_APP_STTS",
            edit: true,
        } /* Application Status !== 신청서 상태 ==! */,
        hsCdNm: {
            type: "text",
            label: "L_HS_CD_NM",
            edit: true,
        } /* HS Code Name !==  Hs code 명 ==! */,
        srchCntyOrigCd: {
            type: "code",
            area: "cntyCd",
            label: "L_CNTY_ORIG",
            edit: true,
        } /* Country of Origin !== 원산지 국가 ==! */,
        srchAppTpCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0113",
            label: "L_APP_TP",
            all: true,
            edit: true,
        } /* Application Type Code !== 신청서 유형 코드 ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchNreglYn: {
            type: "select",
            label: "L_NREG_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            all: true,
            viewType: "both",
            edit: true,
        } /* Non-Regulated Yes or not !== 비규제 여부 ==! */,
        srchLpcoSttsCd: {
            type: "select",
            label: "L_APP_STTS",
            area: "comnCd",
            comnCd: "OSC0121",
            excludes: ["DR", "AM", "SP", "I1", "I5"],
            all: true,
            edit: true,
        } /* LPCO Status Code !== LPCO 상태 코드 ==! */,
        srchTansadSttsCd: {
            type: "select",
            label: "L_TANSAD_STTS",
            area: "comnCd",
            comnCd: "OSC0018",
            all: true,
            edit: true,
        } /* TANSAD Status Code !== TANSAD 상태 코드 ==! */,
        srchDtLb: {
            label: "L_DT",
            required: true,
        } /* Date label !== 날짜 라벨(화면표시용) ==! */,
        srchDtDvn: {
            type: "select",
            select: false,
            only: "control",
            defaultValue: "A",
            options: [
                { label: "L_SBMS_DT", value: "S" },
                { label: "L_APRV_DT", value: "A" },
            ],
        } /* Date Division !== 날짜 구분 ==! */,
        srchDt: {
            type: "daterange",
            // label: "L_DT",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchStrtDt" },
            end: { name: "srchEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 날짜 검색 조건(Trade 메뉴에서 사용) ==! */,
    },
};

export const SF_ORG_LPCO_RPRT: TFormSchema = {
    id: "form_orgLpcoRprt",
    schema: {
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchAppCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            all: true,
        } /* LPCO !== LPCO ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchPrdDvnCd: {
            type: "radio",
            label: "L_TIME_ITRV",
            area: "comnCd",
            comnCd: "OSC0141",
            edit: true,
            excludes: ["H"],
        } /* Time Interval !== 시간 간격 ==! */,
        srchCustomRnge: {
            type: "daterange",
            label: "L_DT_RNGE",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchCustomStrtDt" },
            end: { name: "srchCustomEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 사용자 정의 날짜 간격 ==! */,
        srchStrYear: {
            type: "select",
            label: "L_CTRA_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year !== 시작 년도 ==! */,
        srchEndYear: {
            type: "select",
            label: "L_END_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year !== 종료 년도 ==! */,
        srchStrQrtYy: {
            type: "select",
            label: "L_STRT_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Quarter Year !== 시작 분기 년도 ==! */,
        srchStrQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* Start Quarter !== 시작 분기 ==! */,
        srchEndQrtYy: {
            type: "select",
            label: "L_END_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Quarter Year !== 종료 분기 년도 ==! */,
        srchEndQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* End Quarter !== 종료 분기 ==! */,
        srchStrYmYy: {
            type: "select",
            label: "L_STRT_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year and Month !== 시작 연월 년도 ==! */,
        srchStrYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* Start Year and Month !== 시작 연월 월 ==! */,
        srchEndYmYy: {
            type: "select",
            label: "L_END_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year and Month !== 종료 연월 년도 ==! */,
        srchEndYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* End Year and Month !== 종료 연월 월 ==! */,
    },
};

export const SF_HSCD_RPRT: TFormSchema = {
    id: "form_hscdRprt",
    schema: {
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchAppCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            all: true,
        } /* LPCO !== LPCO ==! */,
        srchHsCd: {
            type: "code",
            label: "L_HS_CD",
            area: "hsCd",
            edit: true,
        } /* HS code !== HS code ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchPrdDvnCd: {
            type: "radio",
            label: "L_TIME_ITRV",
            area: "comnCd",
            comnCd: "OSC0141",
            edit: true,
            excludes: ["H"],
        } /* Time Interval !== 시간 간격 ==! */,
        srchCustomRnge: {
            type: "daterange",
            label: "L_DT_RNGE",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchCustomStrtDt" },
            end: { name: "srchCustomEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 사용자 정의 날짜 간격 ==! */,
        srchStrYear: {
            type: "select",
            label: "L_CTRA_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year !== 시작 년도 ==! */,
        srchEndYear: {
            type: "select",
            label: "L_END_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year !== 종료 년도 ==! */,
        srchStrQrtYy: {
            type: "select",
            label: "L_STRT_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Quarter Year !== 시작 분기 년도 ==! */,
        srchStrQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* Start Quarter !== 시작 분기 ==! */,
        srchEndQrtYy: {
            type: "select",
            label: "L_END_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Quarter Year !== 종료 분기 년도 ==! */,
        srchEndQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* End Quarter !== 종료 분기 ==! */,
        srchStrYmYy: {
            type: "select",
            label: "L_STRT_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year and Month !== 시작 연월 년도 ==! */,
        srchStrYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* Start Year and Month !== 시작 연월 월 ==! */,
        srchEndYmYy: {
            type: "select",
            label: "L_END_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year and Month !== 종료 연월 년도 ==! */,
        srchEndYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* End Year and Month !== 종료 연월 월 ==! */,
    },
};

export const SF_CNTY_TRDE_RPRT: TFormSchema = {
    id: "form_cntyTrdeRprt",
    schema: {
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==! */,
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchAppCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            all: true,
        } /* LPCO !== LPCO ==! */,
        srchHsCd: {
            type: "code",
            label: "L_HS_CD",
            area: "hsCd",
            edit: true,
        } /* HS code !== HS code ==! */,
        srchCntyOrigCd: {
            type: "code",
            label: "L_CNTY_ORIG",
            area: "cntyCd",
            edit: true,
        } /* Country of Origin !== 원산지 국가 ==! */,
        appStts: {
            type: "select",
            label: "L_APP_STTS",
            edit: true,
        } /* Application Status !== 신청서 상태 ==! */,
        srchAppTpCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0113",
            label: "L_APP_TP",
            all: true,
            edit: true,
        } /* Application Type Code !== 신청서 유형 코드 ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchLpcoSttsCd: {
            type: "select",
            label: "L_APP_STTS",
            area: "comnCd",
            comnCd: "OSC0121",
            all: true,
            edit: true,
            excludes: ["DR", "AM", "SP"],
        } /* LPCO Status Code !== LPCO 상태 코드 ==! */,
        srchTansadSttsCd: {
            type: "select",
            label: "L_TANSAD_STTS",
            area: "comnCd",
            comnCd: "OSC0018",
            all: true,
            edit: true,
        } /* TANSAD Status Code !== TANSAD 상태 코드 ==! */,
        srchDtLb: {
            label: "L_DT",
            required: true,
        } /* Date label !== 날짜 라벨(화면표시용) ==! */,
        srchDtDvn: {
            type: "select",
            select: false,
            only: "control",
            defaultValue: "A",
            options: [
                { label: "L_SBMS_DT", value: "S" },
                { label: "L_APP_DT", value: "A" },
            ],
        } /* Date Division !== 날짜 구분 ==! */,
        srchDt: {
            type: "daterange",
            // label: "L_DT",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchStrtDt" },
            end: { name: "srchEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 날짜 검색 조건(Trade 메뉴에서 사용) ==! */,
    },
};

export const SF_AL_PAY_RPRT: TFormSchema = {
    id: "form_alPayRprt",
    schema: {
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchPrdDvnCd: {
            type: "radio",
            label: "L_TIME_ITRV",
            area: "comnCd",
            comnCd: "OSC0141",
            edit: true,
            excludes: ["H"],
        } /* Time Interval !== 시간 간격 ==! */,
        srchCustomRnge: {
            type: "daterange",
            label: "L_DT_RNGE",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchCustomStrtDt" },
            end: { name: "srchCustomEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 사용자 정의 날짜 간격 ==! */,
        srchStrYear: {
            type: "select",
            label: "L_CTRA_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year !== 시작 년도 ==! */,
        srchEndYear: {
            type: "select",
            label: "L_END_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year !== 종료 년도 ==! */,
        srchStrQrtYy: {
            type: "select",
            label: "L_STRT_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Quarter Year !== 시작 분기 년도 ==! */,
        srchStrQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* Start Quarter !== 시작 분기 ==! */,
        srchEndQrtYy: {
            type: "select",
            label: "L_END_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Quarter Year !== 종료 분기 년도 ==! */,
        srchEndQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* End Quarter !== 종료 분기 ==! */,
        srchStrYmYy: {
            type: "select",
            label: "L_STRT_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year and Month !== 시작 연월 년도 ==! */,
        srchStrYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* Start Year and Month !== 시작 연월 월 ==! */,
        srchEndYmYy: {
            type: "select",
            label: "L_END_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year and Month !== 종료 연월 년도 ==! */,
        srchEndYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* End Year and Month !== 종료 연월 월 ==! */,
        srchFeeCurrCd: {
            type: "radio",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            all: true,
        },
    },
};

export const SF_BLL_STTS_RPRT: TFormSchema = {
    id: "form_bllSttsRprt",
    schema: {
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchPrdDvnCd: {
            type: "radio",
            label: "L_TIME_ITRV",
            area: "comnCd",
            comnCd: "OSC0141",
            edit: true,
            excludes: ["H"],
        } /* Time Interval !== 시간 간격 ==! */,
        srchCustomRnge: {
            type: "daterange",
            label: "L_DT_RNGE",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchCustomStrtDt" },
            end: { name: "srchCustomEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 사용자 정의 날짜 간격 ==! */,
        srchStrYear: {
            type: "select",
            label: "L_CTRA_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year !== 시작 년도 ==! */,
        srchEndYear: {
            type: "select",
            label: "L_END_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year !== 종료 년도 ==! */,
        srchStrQrtYy: {
            type: "select",
            label: "L_STRT_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Quarter Year !== 시작 분기 년도 ==! */,
        srchStrQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* Start Quarter !== 시작 분기 ==! */,
        srchEndQrtYy: {
            type: "select",
            label: "L_END_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Quarter Year !== 종료 분기 년도 ==! */,
        srchEndQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* End Quarter !== 종료 분기 ==! */,
        srchStrYmYy: {
            type: "select",
            label: "L_STRT_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year and Month !== 시작 연월 년도 ==! */,
        srchStrYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* Start Year and Month !== 시작 연월 월 ==! */,
        srchEndYmYy: {
            type: "select",
            label: "L_END_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year and Month !== 종료 연월 년도 ==! */,
        srchEndYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* End Year and Month !== 종료 연월 월 ==! */,
        srchBllStatCd: {
            type: "radio",
            label: "L_BLL_STTS",
            area: "comnCd",
            comnCd: "OSC0122",
            all: true,
            // Query excludes paid bills (PC/PG) !== 쿼리가 납부 건(PC/PG)을 제외하므로 선택지에서도 뺀다 ==!
            excludes: ["PC", "PG"],
            // Expired is not a status code — bill expiry date has passed !== 만료는 상태값이 아니라 만료일 경과다 ==!
            includes: [{ value: "XP", label: "Expired" }],
        },
    },
};

export const SF_GFS_CD_RPRT: TFormSchema = {
    id: "form_gfsCdRprt",
    schema: {
        orgCd: {
            type: "select",
            area: "orgCd",
            label: "L_OGA",
            edit: true,
            viewType: "label",
        } /* OGA !== OGA ==! */,
        srchCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: true,
        } /* Customs Office Code !== 세관 코드 ==! */,
        srchPrdDvnCd: {
            type: "radio",
            label: "L_TIME_ITRV",
            area: "comnCd",
            comnCd: "OSC0141",
            edit: true,
            excludes: ["H"],
        } /* Time Interval !== 시간 간격 ==! */,
        srchCustomRnge: {
            type: "daterange",
            label: "L_DT_RNGE",
            rangeButton: 4,
            controlSize: 10,
            start: { name: "srchCustomStrtDt" },
            end: { name: "srchCustomEndDt" },
            edit: true,
            required: true,
        } /* Date Range !== 사용자 정의 날짜 간격 ==! */,
        srchStrYear: {
            type: "select",
            label: "L_CTRA_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year !== 시작 년도 ==! */,
        srchEndYear: {
            type: "select",
            label: "L_END_YY",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year !== 종료 년도 ==! */,
        srchStrQrtYy: {
            type: "select",
            label: "L_STRT_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Quarter Year !== 시작 분기 년도 ==! */,
        srchStrQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* Start Quarter !== 시작 분기 ==! */,
        srchEndQrtYy: {
            type: "select",
            label: "L_END_QRT",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Quarter Year !== 종료 분기 년도 ==! */,
        srchEndQrt: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchQuarterArr(),
        } /* End Quarter !== 종료 분기 ==! */,
        srchStrYmYy: {
            type: "select",
            label: "L_STRT_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* Start Year and Month !== 시작 연월 년도 ==! */,
        srchStrYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* Start Year and Month !== 시작 연월 월 ==! */,
        srchEndYmYy: {
            type: "select",
            label: "L_END_YM",
            edit: true,
            required: true,
            options: APIS.getSrchYearArr(),
        } /* End Year and Month !== 종료 연월 년도 ==! */,
        srchEndYmMm: {
            type: "select",
            edit: true,
            required: true,
            options: APIS.getSrchMonthArr(),
        } /* End Year and Month !== 종료 연월 월 ==! */,
        srchFeeCurrCd: {
            type: "radio",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            all: true,
        },
    },
};

export const SG_STSTCL_SELC_LPCO: TGridSchema = {
    id: "grid_lpco",
    options: { pagination: false, edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        { cells: [{ header: "L_YY", binding: "ststclYy", width: 120 }], id: "ststclYy" },
        { cells: [{ header: "L_QRT", binding: "ststclQrt", width: 120 }], id: "ststclQrt", show: false },
        { cells: [{ header: "L_MM", binding: "ststclMm", width: 120 }], id: "ststclMm", show: false },
        { cells: [{ header: "L_LPCO", binding: "appNm", width: "*" }], id: "appNm" },
        { cells: [{ header: "L_CNT", binding: "cnt", width: 150 }], id: "cnt" },
    ],
    body: [
        {
            cells: [{ binding: "orgNm", align: "left" }] /* OGA !== OGA ==!*/,
        },
        {
            cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/,
        },
        {
            cells: [{ binding: "ststclQrt" }] /* Quarter !== 분기 ==!*/,
        },
        {
            cells: [{ binding: "ststclMm" }] /* Quarter !== 월 ==!*/,
        },
        {
            cells: [{ binding: "appNm", align: "left" }] /* LPCO !== LPCO ==!*/,
        },
        {
            cells: [{ binding: "cnt" }] /* Count !== 개수 ==!*/,
        },
    ],
};

export const SG_STSTCL_SELC_HSCODE: TGridSchema = {
    id: "grid_hscode",
    options: { pagination: "in", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        { cells: [{ header: "L_YY", binding: "ststclYy", width: 120 }], id: "ststclYy" },
        { cells: [{ header: "L_QRT", binding: "ststclQrt", width: 120 }], id: "ststclQrt", show: false },
        { cells: [{ header: "L_MM", binding: "ststclMm", width: 120 }], id: "ststclMm", show: false },
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 180 }], id: "hsCd" },
        { cells: [{ header: "L_HS_CD_NM", binding: "hsDesc", width: "*" }], id: "hsDesc" },
        { cells: [{ header: "L_REGM_TP", binding: "ucrRegmCdNm", width: 150 }], id: "ucrRegmCdNm" },
        { cells: [{ header: "L_CNT", binding: "cnt", width: 150 }], id: "cnt" },
    ],
    body: [
        {
            cells: [{ binding: "orgNm", align: "left" }] /* OGA !== OGA ==!*/,
        },
        {
            cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/,
        },
        {
            cells: [{ binding: "ststclQrt" }],
        },
        {
            cells: [{ binding: "ststclMm" }],
        },
        {
            cells: [{ binding: "hsCd", align: "center" }] /* Hs code !==  Hs code ==!*/,
        },
        {
            cells: [{ binding: "hsDesc", align: "left" }] /* HS Code Name !==  Hs code 명 ==!*/,
        },
        {
            cells: [{ binding: "ucrRegmCdNm" }] /* Regime Type !==  영역 유형 ==!*/,
        },
        {
            cells: [{ binding: "cnt" }] /* Count !== 개수 ==!*/,
        },
    ],
};

export const SG_STSTCL_SELC_OGA: TGridSchema = {
    id: "grid_oga",
    options: { pagination: false, edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        { cells: [{ header: "L_YY", binding: "ststclYy", width: 120 }], id: "ststclYy" },
        { cells: [{ header: "L_QRT", binding: "ststclQrt", width: 120 }], id: "ststclQrt", show: false },
        { cells: [{ header: "L_MM", binding: "ststclMm", width: 120 }], id: "ststclMm", show: false },
        { cells: [{ header: "L_LPCO", binding: "appNm", width: "*" }], id: "appNm" },
        { cells: [{ header: "L_CNT", binding: "cnt", width: 150 }], id: "cnt" },
    ],
    body: [
        {
            cells: [{ binding: "orgNm", align: "left" }] /* OGA !== OGA ==!*/,
        },
        {
            cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/,
        },
        {
            cells: [{ binding: "ststclQrt" }] /* Quarter !== 분기 ==!*/,
        },
        {
            cells: [{ binding: "ststclMm" }] /* Quarter !== 월 ==!*/,
        },
        {
            cells: [{ binding: "appNm", align: "left" }] /* LPCO !== LPCO ==!*/,
        },
        {
            cells: [{ binding: "cnt" }] /* Count !== 개수 ==!*/,
        },
    ],
};

export const SG_STSTCL_SELC_TRDE: TGridSchema = {
    id: "grid_trade",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: false },
    head: [
        {
            cells: [{ header: "L_APP_NO", binding: "appNo", width: 200 }],
            id: "appNo",
        } /* Application No !== 신청번호 ==! */,
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: 270 }], id: "ucrNo" } /* UCR No !== UCR번호 ==! */,
        {
            cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: 150 }],
            id: "tansadNo",
        } /* TANSAD Number !== TANSAD_번호 ==! */,
        {
            cells: [{ header: "L_CSTM_VAL", binding: "cstmVal", width: 130 }],
            id: "cstmVal",
        } /* Customs Value !== 관세비용(외화) ==! */,
        {
            cells: [{ header: "L_CNTY_ORIG", binding: "origCntyCd", width: 200 }],
            id: "origCntyCd",
        } /* Country of Origin !== 원산지 국가 ==! */,
        { cells: [{ header: "L_EXPPN", binding: "exppn", width: 450 }], id: "exppn" } /* Exporter !== 수출자 ==! */,
        { cells: [{ header: "L_IMPPN", binding: "imppn", width: 450 }], id: "imppn" } /* Importer !== 수입자 ==! */,
        { cells: [{ header: "L_HS", binding: "hsCd", width: 150 }], id: "hsCd" } /* HS !== HS ==! */,
        {
            cells: [{ header: "L_ITM_DESC", binding: "itmDesc", width: "*", minWidth: 400 }],
            id: "itmDesc",
        } /* Item Description !== 물품설명 ==! */,
        {
            cells: [{ header: "L_APP", binding: "appCdNm", width: 300 }],
            id: "appCdNm",
        } /* Application !== 신청서명(화면표시용) ==! */,
        {
            cells: [{ header: "L_APP_TP", binding: "appTpCd", width: 200 }],
            id: "appTpCd",
        } /* Application Type Name !== 신청서_유형_코드명 ==! */,
        {
            cells: [{ header: "L_CSTM_OFCE", binding: "cstmOfceCd", width: 350 }],
            id: "cstmOfceNm",
        } /* Customs Office !== 세관코드 ==! */,
        {
            cells: [{ header: "L_SBMS_DT", binding: "sbmtDtm", width: 100 }],
            id: "sbmtDtm",
        } /* Submission Date !== 제출일자 ==! */,
        {
            cells: [{ header: "L_APRV_DT", binding: "aprvDtm", width: 100 }],
            id: "aprvDtm",
        } /* Approval Date !== 승인일자 ==!*/,
        {
            cells: [{ header: "L_NREG_YN", binding: "nregYn", width: 100 }],
            id: "nregYn",
        } /* Non-Regulate Yes or not !== 비규제_여부 ==! */,
        {
            cells: [{ header: "L_APP_STTS", binding: "appStatCd", width: 150 }],
            id: "appStatCd",
        } /* Application Status !== 신청서상태 ==! */,
        {
            cells: [{ header: "L_TANSAD_STTS", binding: "dclrPrcssSttsCd", width: 150 }],
            id: "dclrPrcssSttsCd",
        } /* TANSAD Status !== TANSAD 상태 ==! */,
    ],
    body: [
        { cells: [{ binding: "appNo", type: "text", align: "center" }] } /* Application No !== 신청서 번호 ==! */,
        { cells: [{ binding: "ucrNo", type: "text", align: "center" }] } /* UCR No !== UCR 번호 ==!*/,
        { cells: [{ binding: "tansadNo", type: "text", align: "center" }] } /* TANSAD No !== TANSAD 번호 ==! */,
        { cells: [{ binding: "cstmVal", type: "number", align: "right" }] } /* Customs Value !== 관세비용(외화) ==! */,
        {
            cells: [{ binding: "origCntyCd", type: "code", area: "cntyCd", align: "left" }],
        } /* Country of Origin !== 원산지 국가 ==! */,
        { cells: [{ binding: "exppn", type: "text", align: "left" }] } /* Exporter !== 수출자 ==! */,
        { cells: [{ binding: "imppn", type: "text", align: "left" }] } /* Importer !== 수입자 ==! */,
        {
            cells: [
                {
                    binding: "hsCd",
                    type: "text",
                    area: "hsCd",
                    align: "center",
                    mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
                },
            ],
        } /* HS !== HS ==! */,
        { cells: [{ binding: "itmDesc", type: "text", align: "left" }] } /* Item Description !== 물품설명 ==! */,
        { cells: [{ binding: "appCdNm", type: "text", align: "left" }] } /* Application !== 신청서명(화면표시용) ==! */,
        {
            cells: [{ binding: "appTpCd", type: "code", area: "comnCd", comnCd: "OSC0113", align: "left" }],
        } /* Application Type Name !== 신청서_유형_코드명 ==! */,
        {
            cells: [{ binding: "cstmOfceCd", type: "code", area: "comnCd", comnCd: "OSC0077", align: "left" }],
        } /* Customs Office !== 세관코드 ==! */,
        { cells: [{ binding: "sbmtDtm", type: "date", align: "center" }] } /* Submission Date !== 제출일자 ==! */,
        { cells: [{ binding: "aprvDtm", type: "date", align: "center" }] } /* Approval Date !== 승인일자 ==!*/,
        {
            cells: [{ binding: "nregYn", type: "text", align: "center" }],
        } /* Non-Regulate Yes or not !== 비규제_여부 ==! */,
        {
            cells: [{ binding: "appStatCd", type: "code", area: "comnCd", comnCd: "OSC0121", align: "center" }],
        } /* Application Status !== 신청서상태 ==! */,
        {
            cells: [{ binding: "dclrPrcssSttsCd", type: "code", area: "comnCd", comnCd: "OSC0018", align: "center" }],
        } /* TANSAD Status !== TANSAD 상태 ==! */,
    ],
};

export const SG_ORG_LPCO_RPRT: TGridSchema = {
    id: "grid_orgLpcoRprt",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        // { cells: [{ header: "L_YY", binding: "ststclYy", width: "*" }], id: "ststclYy" },
        // { cells: [{ header: "L_QRT", binding: "ststclQrt", width: "*" }], id: "ststclQrt", show: false },
        // { cells: [{ header: "L_MM", binding: "ststclMm", width: "*" }], id: "ststclMm", show: false },
        { cells: [{ header: "L_APP_TP", binding: "appImexTpNm", width: 150 }], id: "appImexTpNm" },
        { cells: [{ header: "L_LPCO", binding: "appNm", width: "*" }], id: "appNm" },
        { cells: [{ header: "L_CNT", binding: "cnt", width: 150 }], id: "cnt" },
    ],
    body: [
        {
            cells: [{ binding: "orgNm", align: "left" }] /* OGA !== OGA ==!*/,
        },
        // {
        //     cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/,
        // },
        // {
        //     cells: [{ binding: "ststclQrt" }] /* Quarter !== 분기 ==!*/,
        // },
        // {
        //     cells: [{ binding: "ststclMm" }] /* Quarter !== 월 ==!*/,
        // },
        {
            cells: [{ binding: "appImexTpNm", align: "center" }] /* Application Type !== 신청서 유형 ==!*/,
        },
        {
            cells: [{ binding: "appNm", align: "left" }] /* LPCO !== LPCO ==!*/,
        },
        {
            cells: [{ binding: "cnt" }] /* Count !== 개수 ==!*/,
        },
    ],
};

export const SG_HSCD_RPRT: TGridSchema = {
    id: "grid_hscdRprt",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        // { cells: [{ header: "L_YY", binding: "ststclYy", width: "*" }], id: "ststclYy" },
        // { cells: [{ header: "L_QRT", binding: "ststclQrt", width: "*" }], id: "ststclQrt", show: false },
        // { cells: [{ header: "L_MM", binding: "ststclMm", width: "*" }], id: "ststclMm", show: false },
        { cells: [{ header: "L_APP_TP", binding: "appImexTpNm", width: 150 }], id: "appImexTpNm" },
        { cells: [{ header: "L_LPCO", binding: "appNm", width: "*" }], id: "appNm" },
        { cells: [{ header: "L_HS", binding: "hsCd", width: 180 }], id: "hsCd" },
        { cells: [{ header: "L_HS_CD_NM", binding: "hsDesc", width: "*" }], id: "hsDesc" },
        { cells: [{ header: "L_CNT", binding: "cnt", width: 150 }], id: "cnt" },
    ],
    body: [
        { cells: [{ binding: "orgNm", align: "left" }] /* OGA !== OGA ==!*/ },
        // { cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/ },
        // { cells: [{ binding: "ststclQrt" }] /* Quarter !== 분기 ==!*/ },
        // { cells: [{ binding: "ststclMm" }] /* Quarter !== 월 ==!*/ },
        { cells: [{ binding: "appImexTpNm", align: "center" }] /* Application Type !== 신청서 유형 ==!*/ },
        { cells: [{ binding: "appNm", align: "left" }] /* LPCO !== LPCO ==!*/ },
        { cells: [{ binding: "hsCd", align: "center" }] /* HS !== HS ==!*/ },
        { cells: [{ binding: "hsDesc", align: "left" }] /* HS Code Name !== HS코드명 ==!*/ },
        { cells: [{ binding: "cnt" }] /* Count !== 개수 ==!*/ },
    ],
};

export const SG_CNTY_TRDE_RPRT: TGridSchema = {
    id: "grid_cntyTrdeRprt",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: false },
    head: [
        {
            cells: [{ header: "L_APP_NO", binding: "appNo", width: 200 }],
            id: "appNo",
        } /* Application No !== 신청번호 ==! */,
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: 270 }], id: "ucrNo" } /* UCR No !== UCR번호 ==! */,
        {
            cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: 200 }],
            id: "tansadNo",
        } /* TANSAD Number !== TANSAD_번호 ==! */,
        {
            cells: [{ header: "L_CSTM_VAL", binding: "cstmVal", width: 150 }],
            id: "cstmVal",
        } /* Customs Value !== 관세비용(외화) ==! */,
        {
            cells: [{ header: "L_CNTY_ORIG", binding: "origCntyCd", width: 200 }],
            id: "origCntyCd",
        } /* Country of Origin !== 원산지 국가 ==! */,
        {
            cells: [{ header: "L_EXPPN", binding: "expNm", width: "*", minWidth: 400 }],
            id: "expNm",
        } /* Exporter !== 수출자 ==! */,
        {
            cells: [{ header: "L_IMPPN", binding: "impNm", width: "*", minWidth: 400 }],
            id: "impNm",
        } /* Importer !== 수입자 ==! */,
        { cells: [{ header: "L_HS", binding: "hsCd", width: 150 }], id: "hsCd" } /* HS !== HS ==! */,
        {
            cells: [{ header: "L_ITM_DESC", binding: "itmDesc", width: "*", minWidth: 400 }],
            id: "itmDesc",
        } /* Item Description !== 물품설명 ==! */,
        {
            cells: [{ header: "L_CSTM_OFCE", binding: "cstmOfceCd", width: 150 }],
            id: "cstmOfceCd",
        } /* Customs Office !== 세관코드 ==! */,
        {
            cells: [{ header: "L_APP_STTS", binding: "appStatCd", width: 150 }],
            id: "appStatCd",
        } /* Application Status !== 신청서상태 ==! */,
        {
            cells: [{ header: "L_TANSAD_STTS", binding: "dclrPrcssSttsCd", width: 150 }],
            id: "dclrPrcssSttsCd",
        } /* TANSAD Status !== TANSAD 상태 ==! */,
        {
            cells: [{ header: "L_APP_DT", binding: "appDtm", width: 100 }],
            id: "appDtm",
        },
        {
            cells: [{ header: "L_SBMS_DT", binding: "sbmtDtm", width: 100 }],
            id: "sbmtDtm",
        } /* Submission Date !== 제출일자 ==! */,
    ],
    body: [
        { cells: [{ binding: "appNo", type: "text", align: "center" }] } /* Application No !== 신청서 번호 ==! */,
        { cells: [{ binding: "ucrNo", type: "text", align: "center" }] } /* UCR No !== UCR 번호 ==!*/,
        { cells: [{ binding: "tansadNo", type: "text", align: "center" }] } /* TANSAD No !== TANSAD 번호 ==! */,
        { cells: [{ binding: "cstmVal", type: "number", align: "right" }] } /* Customs Value !== 관세비용(외화) ==! */,
        {
            cells: [{ binding: "origCntyCd", type: "code", area: "cntyCd", align: "left" }],
        } /* Country of Origin !== 원산지 국가 ==! */,
        { cells: [{ binding: "expNm", type: "text", align: "left" }] } /* Exporter !== 수출자 ==! */,
        { cells: [{ binding: "impNm", type: "text", align: "left" }] } /* Importer !== 수입자 ==! */,
        {
            cells: [
                {
                    binding: "hsCd",
                    type: "text",
                    area: "hsCd",
                    align: "center",
                    mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
                },
            ],
        } /* HS !== HS ==! */,
        { cells: [{ binding: "itmDesc", type: "text", align: "left" }] } /* Item Description !== 물품설명 ==! */,
        {
            cells: [{ binding: "cstmOfceCd", type: "text", align: "center" }],
        } /* Customs Office !== 세관코드 ==! */,
        {
            cells: [{ binding: "appStatCd", type: "code", area: "comnCd", comnCd: "OSC0121", align: "center" }],
        } /* Application Status !== 신청서상태 ==! */,
        {
            cells: [{ binding: "dclrPrcssSttsCd", type: "code", area: "comnCd", comnCd: "OSC0018", align: "center" }],
        } /* TANSAD Status !== TANSAD 상태 ==! */,
        { cells: [{ binding: "appDtm", type: "date", align: "center" }] },
        { cells: [{ binding: "sbmtDtm", type: "date", align: "center" }] } /* Submission Date !== 제출일자 ==! */,
    ],
};

export const SG_AL_PAY_RPRT: TGridSchema = {
    id: "grid_alPayRprt",
    options: {
        pagination: "out",
        edit: false,
        checkbox: false,
        radio: false,
        index: true,
        // group: false,
        group: ["currCd"],
    },
    head: [
        { cells: [{ header: "L_CTRL_NO", binding: "payCtrlNo", width: "*" }], id: "payCtrlNo" },
        { cells: [{ header: "L_BLL_REF", binding: "bllRef", width: "*" }], id: "bllRef" },
        { cells: [{ header: "L_RCPT_NO2", binding: "rcptNo", width: "*" }], id: "rcptNo" },
        { cells: [{ header: "L_PSP_RCPT_NO", binding: "pspReffId", width: "*" }], id: "pspReffId" },
        { cells: [{ header: "L_PYER_ITM_DTL", binding: "pyerItmDtl", width: "*" }], id: "pyerItmDtl" },
        { cells: [{ header: "L_RCV_DT", binding: "zmpTrscDtm", width: "*" }], id: "rcvDt" },
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: 100 }], id: "currCd" },
        { cells: [{ header: "L_AMT_PAID", binding: "payAmt", width: "*" }], id: "amtPaid" },
        { cells: [{ header: "L_EQV_AMT", binding: "eqvAmt", width: "*" }], id: "eqvAmt" },
        { cells: [{ header: "L_BLL_AMT", binding: "bllAmt", width: "*" }], id: "bllAmt" },
    ],
    body: [
        { cells: [{ binding: "payCtrlNo", type: "text", align: "center" }] },
        { cells: [{ binding: "bllRef", type: "text", align: "center" }] },
        { cells: [{ binding: "rcptNo", type: "text", align: "center" }] },
        { cells: [{ binding: "pspReffId", type: "text", align: "center" }] },
        { cells: [{ binding: "pyerItmDtl", type: "text", align: "left" }] },
        { cells: [{ binding: "zmpTrscDtm", type: "date", align: "center" }] },
        { cells: [{ binding: "currCd", type: "text", align: "center" }] },
        { cells: [{ binding: "payAmt", type: "number", align: "right" }] },
        { cells: [{ binding: "eqvAmt", type: "number", align: "right" }] },
        { cells: [{ binding: "bllAmt", type: "number", align: "right" }] },
    ],
    groupFoot: [
        {
            cells: [
                { colspan: 7, text: "L_CUR_SUB_TOT", align: "right", atchKeyValue: true },
                // { colspan: 7, text: "L_TOT_COLT_CNTR_EQV_AMT_PAID", align: "right" },
            ],
        },
        // {
        //     cells: [
        //         { binding: "payAmt", aggregate: "SUM", thousandSeparator: true, align: "right" },
        //         // { colspan: 3, binding: "sumAmt", aggregate: "SUM", thousandSeparator: true, align: "right" },
        //     ],
        // },
        {
            cells: [{ colspan: 3, binding: "eqvAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }],
        },
        // {
        //     cells: [{ binding: "bllAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }],
        // },
    ],
    foot: [
        {
            cells: [{ colspan: 7, text: "L_TOT_COLT_CNTR_EQV_AMT_PAID", align: "right" }],
        },
        {
            cells: [{ colspan: 3, binding: "eqvAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }],
        },
    ],
};

export const SG_BLL_STTS_RPRT: TGridSchema = {
    id: "grid_bllSttsRprt",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, group: ["currCd"] },
    head: [
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }], id: "ctrlNo" },
        { cells: [{ header: "L_BLL_REF", binding: "bllRef", width: "*" }], id: "bllRef" },
        { cells: [{ header: "L_PYER_NM", binding: "pyerNm", width: "*" }], id: "pyerNm" },
        { cells: [{ header: "L_PYER_TLPH", binding: "pyerTlph", width: "*" }], id: "pyerTlph" },
        { cells: [{ header: "L_PYER_EML", binding: "pyerEml", width: "*" }], id: "pyerEml" },
        { cells: [{ header: "L_BLL_GNRT_DT", binding: "bllGnrtDt", width: "*" }], id: "bllGnrtDt" },
        { cells: [{ header: "L_BLL_XPIR_DT", binding: "bllXpirDt", width: "*" }], id: "bllXpirDt" },
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: "*" }], id: "currCd" },
        { cells: [{ header: "L_BLL_EQV_AMT", binding: "bllEqvAmt", width: "*" }], id: "bllEqvAmt" },
        { cells: [{ header: "L_BLL_AMT", binding: "bllAmt", width: "*" }], id: "bllAmt" },
        { cells: [{ header: "L_PRTL_PAID_AMT", binding: "prtlPaidAmt", width: "*" }], id: "prtlPaidAmt" },
    ],
    body: [
        { cells: [{ binding: "ctrlNo", type: "text", align: "center" }] },
        { cells: [{ binding: "bllRef", type: "text", align: "center" }] },
        { cells: [{ binding: "pyerNm", type: "text", align: "left" }] },
        { cells: [{ binding: "pyerTlph", type: "text", align: "left" }] },
        { cells: [{ binding: "pyerEml", type: "text", align: "left" }] },
        // { cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/ },
        // { cells: [{ binding: "ststclQrt" }] /* Quarter !== 분기 ==!*/ },
        // { cells: [{ binding: "ststclMm" }] /* Quarter !== 월 ==!*/ },
        { cells: [{ binding: "bllGnrtDt", type: "date", align: "center" }] },
        { cells: [{ binding: "bllXpirDt", type: "date", align: "center" }] },
        { cells: [{ binding: "currCd", type: "text", align: "center" }] },
        { cells: [{ binding: "bllEqvAmt", type: "number", align: "right" }] },
        { cells: [{ binding: "bllAmt", type: "number", align: "right" }] },
        { cells: [{ binding: "prtlPaidAmt", type: "number", align: "right" }] },
    ],
    groupFoot: [
        {
            cells: [{ colspan: 8, text: "L_CUR_SUB_TOT", align: "right", atchKeyValue: true }],
        },
        {
            cells: [{ colspan: 3, binding: "bllEqvAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }],
        },
    ],
    foot: [
        {
            cells: [{ colspan: 8, text: "L_TOT_COLT_CNTR_EQV_AMT_PAID", align: "right" }],
        },
        {
            cells: [{ colspan: 3, binding: "bllEqvAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }],
        },
    ],
};

export const SG_GFS_CD_RPRT: TGridSchema = {
    id: "grid_gfsCdRprt",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, group: ["currCd"] },

    head: [
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", width: 150 }], id: "gfsCd" },
        { cells: [{ header: "L_GFS_DESC", binding: "gfsDesc", width: "3*" }] },
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: 100 }], id: "currCd" },
        // { cells: [{ header: "L_YY", binding: "ststclYy", width: "*" }], id: "ststclYy" },
        // { cells: [{ header: "L_QRT", binding: "ststclQrt", width: "*" }], id: "ststclQrt", show: false },
        // { cells: [{ header: "L_MM", binding: "ststclMm", width: "*" }], id: "ststclMm", show: false },
        { cells: [{ header: "L_EQV_AMT", binding: "eqvAmt", width: "*" }], id: "eqvAmt" },
    ],
    body: [
        { cells: [{ binding: "gfsCd", align: "center" }] /* GFS Code !== GFS 코드 ==!*/ },
        { cells: [{ binding: "gfsDesc", align: "left" }] /* GFS Description !== GFS 설명 ==!*/ },
        { cells: [{ binding: "currCd", align: "center" }] },
        // { cells: [{ binding: "ststclYy" }] /* Year !== 년도 ==!*/ },
        // { cells: [{ binding: "ststclQrt" }] /* Quarter !== 분기 ==!*/ },
        // { cells: [{ binding: "ststclMm" }] /* Quarter !== 월 ==!*/ },
        { cells: [{ binding: "eqvAmt", type: "number", align: "right" }] /* Count !== 개수 ==!*/ },
    ],
    groupFoot: [
        // { cells: [{ colspan: 3, text: "L_CUR_SUB_TOT", align: "right", atchKeyValue: true }] },
        { cells: [{ colspan: 3, text: "L_TOT_SP_COLT", align: "right", atchKeyValue: true }] },
        { cells: [{ binding: "eqvAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }] },
    ],
    // 전체 최종합계 (맨 아래 1회) !== 전체 총계 ==!
    // foot: [
    //     { cells: [{ colspan: 3, text: "L_TOT_SP_COLT", align: "right" }] },
    //     { cells: [{ binding: "eqvAmt", aggregate: "SUM", thousandSeparator: true, align: "right" }] },
    // ],
};
